import { DEFAULT_TIMEZONE } from 'Data/constants.js'
import { currentTzDate } from 'Data/format.js'
import { useDataValue } from 'Simple/Data'

export default function useGetDefaultTab(props, data) {
  let location = useDataValue({
    context: 'global',
    path: 'current_location',
    viewPath: props.viewPath,
  })
  let parent_company_id = useDataValue({
    context: 'global',
    path: 'current_location.parent_company._id',
    viewPath: props.viewPath,
  })
  let isMediaMobile = useDataValue({
    context: 'media',
    path: 'mobile',
    viewPath: props.viewPath,
  })

  return function ensureDefaultTab(maybeTab, id) {
    if (!data) return data

    let time_zone_id = location.time_zone_id || DEFAULT_TIMEZONE
    let date = currentTzDate(time_zone_id)
    return {
      ...data,
      viewPath: props.viewPath,
      selected: {
        ...data.selected,
        /**
         * If we already have a location selected, we use that. Otherwise, we compute the location
         * based on the global location. We do not modify the location from here even if there is
         * a different one in the sync parameters, because the `SyncSectionParams/logic.js` handles
         * that explicity.
         * Essentially, syncing locations happen in `SyncSectionParams/logic.js` and initialising
         * or reinstating an already selected location happens here
         */
        ...(maybeTab?.selected?.location_id
          ? {
              location_id: maybeTab.selected.location_id,
              vaxiom_location_id: maybeTab.selected.vaxiom_location_id,
              location_name: maybeTab.selected.location_name,
              time_zone_id: maybeTab.selected.time_zone_id,
            }
          : {
              location_id: location._id,
              vaxiom_location_id: location.id,
              location_name: location.name,
              time_zone_id,
            }),
        parent_company_id: maybeTab?.selected?.parent_company_id
          ? maybeTab.selected.parent_company_id
          : parent_company_id,
        date: maybeTab?.selected?.date ? maybeTab.selected.date : date,
        // static value, do not update this value from outside
        location_current_date: currentTzDate(time_zone_id),
        appointment_queue:
          maybeTab?.selected?.appointment_queue ||
          data.selected.appointment_queue,
      },
      sidebar: maybeTab?.sidebar
        ? maybeTab.sidebar
        : {
            ...data.sidebar,
            date,
            is_floating: isMediaMobile,
            is_floating_and_visible: false,
          },
      focused_event_id: maybeTab?.appointment_booking_id ?? null,
      appointment_overlay: maybeTab?.appointment_overlay?.open
        ? maybeTab.appointment_overlay
        : data.appointment_overlay,
      optimal_date: maybeTab?.optimal_date ?? null,
      is_full_width: maybeTab?.is_full_width ?? data.is_full_width,
      screen_width: maybeTab?.screen_width ?? data.screen_width,
      timegrid_width: maybeTab?.timegrid_width ?? data.timegrid_width,
      event_update_timestamp:
        maybeTab?.event_update_timestamp ?? data.event_update_timestamp,
      scheduling: maybeTab?.scheduling ?? data.scheduling,
      global_location: maybeTab?.global_location ?? data.global_location,
    }
  }
}
